import { Link } from "@tanstack/react-router";

import { Button } from "~/components/ui/button";
import { RESPONSIVE_TEXT_BUTTON_CLASS } from "~/lib/touchTarget";

interface AutomationLoadFailureProps {
  readonly error: string;
  readonly onRetry: () => void;
}

export function AutomationLoadFailure({ error, onRetry }: AutomationLoadFailureProps) {
  return (
    <main className="grid min-h-0 flex-1 place-items-center px-4 text-center">
      <div className="max-w-sm">
        <h1 className="text-lg font-semibold">Unable to load automation</h1>
        <p className="mt-2 text-sm text-muted-foreground">{error}</p>
        <div className="mt-4 flex flex-wrap justify-center gap-2">
          <Button className={RESPONSIVE_TEXT_BUTTON_CLASS} onClick={onRetry}>
            Retry
          </Button>
          <Button
            className={RESPONSIVE_TEXT_BUTTON_CLASS}
            render={<Link to="/automations" />}
            variant="ghost"
          >
            Back to automations
          </Button>
        </div>
      </div>
    </main>
  );
}
